import {ApiV0Administration} from '../api.v0.administration';
import {RestApiService} from '../../../rest-api.service';
import {BaseCollectionModel, SearchModel, YascEntityApiAdapterV3} from '@yasc/yasc-material-components';
import {Observable} from 'rxjs';
import {AVariableReq, AVariableRes, AVariableResolvePreviewReq, AVariableResolvePreviewRes} from '../../../../contracts/v0/administration/variable.contracts';

export class ApiV0AdminVariables implements YascEntityApiAdapterV3<AVariableRes, AVariableRes, AVariableReq, AVariableReq, number> {
    readonly idKey = 'id' as const;
    readonly modelTypes = {
        row: AVariableRes,
        detail: AVariableRes,
        create: AVariableReq,
        patch: AVariableReq,
    };

    segment = '/variables';

    constructor(
        v0: ApiV0Administration,
        private rest: RestApiService
    ) {
        this.segment = v0.segment + this.segment;
    }

    search(dto?: SearchModel): Observable<BaseCollectionModel<AVariableRes>> {
        dto = dto ?? new SearchModel({});
        return this.rest.post<SearchModel, BaseCollectionModel<AVariableRes>>(`${this.segment}/search`, AVariableRes, dto);
    }

    resolvePreview(req: AVariableResolvePreviewReq): Observable<AVariableResolvePreviewRes> {
        return this.rest.post<AVariableResolvePreviewReq, AVariableResolvePreviewRes>(
            `${this.segment}/ResolvePreview`,
            AVariableResolvePreviewRes,
            req,
        );
    }

    detail(id: number): Observable<AVariableRes> {
        return this.rest.get<AVariableRes>(`${this.segment}/${id}`, AVariableRes);
    }

    patch(id: number, req: AVariableReq): Observable<AVariableRes> {
        return this.rest.patch<AVariableReq, AVariableRes>(`${this.segment}/${id}`, AVariableRes, req);
    }

    update(id: number, req: AVariableReq): Observable<AVariableRes> {
        return this.patch(id, req);
    }
}
